<script lang="ts">
  import { Wallet } from '@entities/wallet';

  import { ArtworksPurchasedList } from '@features/artwork/artworks-purchased-list';
</script>

<section>
  <div class="mb-8">
    <Wallet />
  </div>

  <ArtworksPurchasedList />
</section>
